import React, { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
} from "@mui/material";
import { _get_i18Lang } from "../i18n";

import "../Styles/Login.css";
import "../Styles/Profile.css";
import "react-phone-number-input/style.css";
import 'react-international-phone/style.css'; // Importing library styles
import { Button, Alert } from "react-bootstrap";
import Loader from "./Loader";

interface LogOutModalProps {
  open: boolean;
  onClose: () => void;
}

export const LogOutModel: React.FC<LogOutModalProps> = ({ open, onClose }) => {
  const currentLanguage = _get_i18Lang();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  const handlelogout = () => {
    setLoading(false);
    setTimeout(() => {
      localStorage.clear();
      localStorage.removeItem("Phone");
      localStorage.removeItem("UserId");
      localStorage.removeItem("UserName");
      localStorage.removeItem("Image");
      localStorage.removeItem("email");
      localStorage.removeItem("mobileNo");
      localStorage.removeItem("Token");
      if (window.location.pathname?.includes("profile")) navigate(`/`);
      window.location.reload();
      setLoading(true);
      onClose();
    }, 1000)
  }

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogContent>
        <DialogContentText>
          <div>
            <label
              style={{
                fontSize: "16px",
                textAlign: "center",
                color: "#000",
                width: "225px",
                margin: "0 0 -20px 0",
                padding: "8px 0",
                minHeight: "52px",
                fontFamily: "ChanakyaUni",
                scrollbarWidth: "none",
              }}
            >
              {currentLanguage === "hindi" ? (
                <label>क्या आप गीता सेवा से लॉगआउट करना चाहते हैं?</label>
              ) : (
                <label>Are you sure you want to Logout?</label>
              )}
            </label>
          </div>
        </DialogContentText>
      </DialogContent>
      <DialogActions style={{ display: "flex", justifyContent: "center" }}>
        {!loading ? (
          <Loader loading={!loading} /> // Show your custom loader here
        ) : (
          <>
            <Button
              onClick={handlelogout}
              style={{
                backgroundColor: "#f44336",
                color: "#fff",
                padding: "5px 20px",
              }}
              autoFocus
            >
              Yes
            </Button>
            <Button
              onClick={() => {
                onClose();
              }}
              style={{
                boxShadow:
                  "0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12)",
                color: "#212121",
                boxSizing: "border-box",
                border: "1px solid #E8E8E8",
                background: "#fff",
                padding: "5px 20px",
              }}
              autoFocus
            >
              No
            </Button>
          </>
        )}
      </DialogActions>
    </Dialog>
  );
};